import React, { SVGProps } from 'react'

import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const pulseAnimation = keyframes`
  0%, 100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.2);
  }
`

const AnimatedSVG = styled.svg`
  width: 4rem;
  height: 4rem;
  overflow: visible;

  path:nth-of-type(1) {
    animation: ${pulseAnimation} 0.8s ease-in-out infinite;
    transform-origin: center;
    animation-delay: 0s;
  }

  path:nth-of-type(2) {
    animation: ${pulseAnimation} 0.8s ease-in-out infinite;
    transform-origin: center;
    animation-delay: 0.15s;
  }

  path:nth-of-type(3) {
    animation: ${pulseAnimation} 0.8s ease-in-out infinite;
    transform-origin: center;
    animation-delay: 0.3s;
  }

  path:nth-of-type(4) {
    animation: ${pulseAnimation} 0.8s ease-in-out infinite;
    transform-origin: center;
    animation-delay: 0.45s;
  }
`

const Path = styled.path`
  fill: ${({ theme }) => theme?.ui.colors['navy.100']};
`

export const AnimatedSurglogsLogo = (props: SVGProps<SVGSVGElement>) => (
  <AnimatedSVG
    {...{
      viewBox: '0 0 27 27',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props,
    }}>
    <Path
      {...{
        d: 'M2.78339 21.7736C1.45572 21.7736 0.378967 20.6968 0.378967 19.3691V2.40443C0.378967 1.07675 1.45572 0 2.78339 0C4.11107 0 5.18782 1.07675 5.18782 2.40443V19.3691C5.18782 20.6968 4.11245 21.7736 2.78339 21.7736Z',
      }}
    />
    <Path
      {...{
        d: 'M9.96908 18.9666C8.6414 18.9666 7.56465 17.8898 7.56465 16.5621V13.5387C7.56465 12.211 8.6414 11.1343 9.96908 11.1343C11.2967 11.1343 12.3735 12.211 12.3735 13.5387V16.5621C12.3735 17.8898 11.2967 18.9666 9.96908 18.9666Z',
      }}
    />
    <Path
      {...{
        d: 'M17.1548 26.366C15.8271 26.366 14.7503 25.2892 14.7503 23.9615V18.3282C14.7503 17.0006 15.8271 15.9238 17.1548 15.9238C18.4824 15.9238 19.5592 17.0006 19.5592 18.3282V23.9615C19.5592 25.2892 18.4824 26.366 17.1548 26.366Z',
      }}
    />
    <Path
      {...{
        d: 'M24.3404 21.7736C23.0128 21.7736 21.936 20.6968 21.936 19.3691V8.60713C21.936 7.27946 23.0128 6.2027 24.3404 6.2027C25.6681 6.2027 26.7449 7.27946 26.7449 8.60713V19.3691C26.7449 20.6968 25.6681 21.7736 24.3404 21.7736Z',
      }}
    />
  </AnimatedSVG>
)
